/* eslint-disable react/self-closing-comp */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useReducer } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Grid,
  FormGroup,
  IconButton,
} from "@material-ui/core"; // Remove the unused imports for CHG0073013
import WarningIcon from "@mui/icons-material/Warning";
import FormLabel from "@mui/material/FormLabel";
// import $ from 'jquery';
import clsx from "clsx";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { useHistory } from "react-router-dom";
import { TrendingUpOutlined } from "@material-ui/icons";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import styles from "./LinkageDelete.module.css";
import {
  CustomFormGroup,
  CustomSelect,
  CustomDatePicker,
  ValidatingTextField,
} from "../../components/FormComponents";
import BackButton from "../../components/BackButton/BackButton";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex,
} from "../../constants";
import { withAllowedOperationsProvider } from '../../hocs';
import { CustomTab, Button, AuthChecker } from "../../atomicComponents";
import UserInfoPanel from "../../atomicComponents/UserInfoPanel/UserInfoPanel";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import TableSimple from "../../atomicComponents/TableSimple/TableSimple";
import Table from "../../components/Table/Table";
import { setLogin } from '../../redux/features/auth/actions';

const LinkageDelete = () => {
  const history = useHistory();
  const dispatchNew = useDispatch();

  const { showPopup } = usePopupManager();
  // const baseUrl='http://127.0.0.1:8000/file/'
  const baseUrl = useSelector((state) => state.counter.baseUrl); // useSelector
  const auth = useSelector((state) => state.auth); // useSelector

  const [dynamicColumns, setDynamicColumns] = useState([]);
  const [dynamicColumns1, setDynamicColumns1] = useState([]);
  const [plant, setPlant] = useState(null);
  const [flag, show] = useState(false);
  const [Bc, setBC] = useState(null);
  const [bcArray, setBcArray] = useState([]);
  const [plantArray, setPlantArray] = useState([]);
  const [tableArray, setTableArray] = useState([]);
  const [loader, setLoader] = useState(true);
  const [asnCount, setAsnCount] = useState(0);
  const [chassisOption, setChassisData] = useState([]);
  const [projectOption, setProjectOption] = useState([
    { value: "Projects", label: "Projects" },
    { value: "Indirect Projects", label: "Indirect Projects" },
  ]);
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [businessUnit, setBusinessUnit] = useState([
    { value: "Common", label: "Common" },
  ]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleOpen = () => setIsPopupOpen(true);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [myState, setState] = React.useState({
    poNo: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
  });
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [datesData, setDates] = useState({
    endDate: "",
    startDate: "",
  });

  //
  const [isPopupOpenFormModal, setPopupOpenFormModal] = useState(false);
  const handleOpenFormModal = () => {
    setPopupOpenFormModal(true);
  };
  const handleCloseFormModal = () => setPopupOpenFormModal(false);

  //

  //
  const [reseVC, setReseVC] = useState(false);
  const handleOpenVCResetModal = () => {
    setReseVC(true);
  };
  const handleCloseVCResetModal = () => setReseVC(false);

  //

  const handleClose = () => setIsPopupOpen(false);
  // start
  const [selectedRow, setSelectedRow] = useState([]);
  const handleOpen1 = (selected) => {
    setIsPopupOpen1(true);
    setSelectedRow(selected);
  };
  const [isPopupOpen1, setIsPopupOpen1] = useState(false);
  const handleClose1 = () => setIsPopupOpen1(false);
  const tableColumnData = [
    { minBookableHrs: 2, maxBookableHrs: 8, bookedHrs: 5, otHrs: 1 },
    { minBookableHrs: 3, maxBookableHrs: 6, bookedHrs: 4, otHrs: 0 },
    // Additional rows...
  ];
  const goNext1 = () => {
    actionBaseVC();
  };
  const actionBaseVC = () => {
    let ids = selectedRow.map(({ dbId }) => dbId);
    const remainingData = tableArray.filter(({ dbId }) => !ids.includes(dbId));
    setTableArray(remainingData);
    ids = ids.join().split(",");

    const apiFormatedData = {
      id: ids,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    console.log("apiFormatedDataJson>>>", apiFormatedDataJson);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}Show_Base_Vc_Data/`, {
      method: "DELETE",
      // headers: headerss,
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Data is Succesfully Deleted",
          reload: true,
        });
      })
      .catch((error) => {});
  };

  const baseDefaultColumns = [
    {
      width: 160,
      title: "Person No",
      field: "Person",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Person Name",
      field: "PersonName",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Work Area",
      field: "Work",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "BC No",
      field: "BC",
      enableSearch: true,
      enableFilter: true,
    },

    {
      width: 140,
      title: "Barrel",
      field: "Barrel",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Project Def",
      field: "ProjectD",
      enableSearch: true,
      enableFilter: true,
    },

    {
      width: 140,
      title: "Project Description",
      field: "Project",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "BU",
      field: "BU",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Sub BU",
      field: "Sub",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Platform",
      field: "Platform",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Family",
      field: "Family",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Created Date",
      field: "Created",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Inserted By",
      field: "Inserted",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Insert Emp Name",
      field: "InsertEMP",
      enableSearch: true,
      enableFilter: true,
    },
  ];

  const goNext = () => {
    uploadFileData();
  };

  const ROW_HEIGHT = 38;
  const redirectToApplicationLandingPage = () => {
    history.push("/home");
  };

  const setCount = (count) => {
    setAsnCount(count);
  };

  const initialState = {
    plant: null,
    part: null,
    aqCommodity: null,
    purchaseCommodity: null,
    supplierCode: null,
    supplierDetails: null,
    supplierName: "",
    supplierLocation: "",
    selectedProject: null,
    selectedPO: null,
    inputFields: {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: "",
    },
    errors: {},
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "update":
        return {
          ...state,
          [action.field]: action.value,
        };
      case "reset":
        return {
          ...state,
          ...initialState,
        };
      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    damage,
    invoice,
    part,
    aqCommodity,
    purchaseCommodity,
    supplierCode,
    supplierDetails,
    supplierName,
    supplierLocation,
    selectedProject,
    selectedPO,
    inputFields,
    errors,
  } = state;

  useEffect(() => {
    getData();
    getdate();
  }, []);
  const getdate = () => {
    const headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}Milestone_calendarView/`, {
      method: "GET",
      headers: headerss,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        const endDate = responseJson[0].Part_Details_correction_StartDate;
        const startDate = responseJson[0].Part_Details_correction_EndDate;
        setDates((prevData) => ({ ...prevData, endDate, startDate }));
      })
      .catch((error) => {});
  };
  const showTable = () => {
    getTableData("Yes");
    show(true);
  };

  const getSelectedFields = () => ({
    projectId: selectedProject,
    poNumber: selectedPO,
    commodityGroupId: purchaseCommodity && purchaseCommodity.value,
    aqCommodityGroupId: aqCommodity && aqCommodity.value,
    purchaseBuyerName: inputFields?.purchaseBuyerName,
    kamContactDetails: {
      // id: inputFields,
      name: inputFields?.suppRepresentativeName,
      contactNumber: inputFields?.suppRepresentativeContact,
      emailId: inputFields?.suppRepresentativeEmail,
    },
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails };
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  const runPreSubmissionChecks = () => {
    const selectedFields = getSelectedFields();
    const areFieldsValid = validateFields(selectedFields);

    if (!areFieldsValid) {
      setHighlightMandatoryFields(true);
      // return false;
      return true;
    }
    return true;
  };

  const handleSelect = (selectedOption, name) => {
    if (name == "baseVC") {
      show(false);

      setBC(selectedOption);
      // getPlantData(selectedOption)
    } else {
      setPlant(selectedOption);
    }
  };
  const getTableData = (flagParam) => {
    const apiFormatedData = {
      VC: Bc.value,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    // Show_Base_Vc_Data_for_PV
    fetch(`${baseUrl}Show_Base_Vc_Data/`, {
      method: "POST",
      headers: headerss,
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        const tableData = responseJson.data;
        const excelData = tableData.map(
          (
            {
              id,
              VC,
              Part_number,
              Group_Part_number,
              Plant_code,
              BOM_Level,
              Procurement_type,
              Spl_Procurement_type,
              BOM_Quantity_of_Part,
              Unit_of_Measure_BOM,
              Vendor_Code,
              NAME1,
              SOB,
              Usage_Probability,
              final_bom_qty,
              Purchase_Group_details,
              PO_Number,
              PO_Price,
              Part_Description,
              PO_Date,
              PO_Currency,
              Order_Price_unit,
              Cell_Identifier,
              Blocked_item,
              Exception,
              Exception_Classification,
              BOM_Extraction_Date,
              BOM_Explosion_Date,
              Bulk_material_indicator,
              Ref_interplant_assemble,
              Destination_plant,
              Item_category,
              Po_doc_type,
              Exclusion_Flag,
              Exclusion_Reason,
            },
            indexx
          ) => {
            let obj = {
              id: indexx,
              dbId: id,
              VC,
              Part_number,
              Group_Part_number,
              Plant_code,
              BOM_Level,
              Procurement_type,
              Spl_Procurement_type,
              BOM_Quantity_of_Part,
              Unit_of_Measure_BOM,
              Vendor_Code,
              NAME1,
              SOB,
              Usage_Probability,
              final_bom_qty,
              Purchase_Group_details,
              PO_Number,
              PO_Price,
              Part_Description,
              PO_Date,
              PO_Currency,
              Order_Price_unit,
              Cell_Identifier,
              Blocked_item,
              Bulk_material_indicator,
              Ref_interplant_assemble,
              Destination_plant,
              Item_category,
              Po_doc_type,
              Exception,
              Exception_Classification,
              Exclusion_Flag,
              Exclusion_Reason,
              BOM_Extraction_Date,
              BOM_Explosion_Date,
            };

            return obj;
          }
        );
        setTableArray(excelData);
        if (flagParam == "Yes") {
          exportExcel(excelData);
        }
        setLoader(false);
      })
      .catch((error) => {});
  };
  const goNextForm = () => {
    var url;
    var urlMethod;

    let { userRole, userID } = auth;

    if (userRole.includes("GDC")) {
      url = "ColourVcMISProgress";
      urlMethod = "POST";
    } else if (
      userRole.includes("Purchase") ||
      userRole.includes("Purchase-CV")
    ) {
      url = "ColourVcMISProgress";
      urlMethod = "PUT";
    } else {
      url = "ColourVcMISProgress";
      urlMethod = "POST";
    }
    const apiFormatedData = {
      VC: Bc.value,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}${url}/`, {
      method: urlMethod,
      headers: headerss,
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Data is Succesfully Saved",
          reload: true,
        });
        history.push("/");
      })
      .catch((error) => {});
  };
  const resetVCCall = () => {
    const apiFormatedData = {
      VC: Bc.value,
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}Show_Base_Vc_Data/`, {
      method: "PATCH",
      headers: headerss,
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        showPopup({
          type: MESSAGE_TYPE.SUCCESS,
          contextText: MESSAGE_TYPE.SUCCESS,
          info: "Data is succesfully reset",
          reload: true,
        });
      })
      .catch((error) => {});
  };

  const getData = () => {
    const apiFormatedData = {
      BascVC: "",
      Mfg_plant: "",
    };

    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}Show_Base_Vc_Data/`, {
      method: "GET",
      headers: headerss,
      //    body: apiFormatedDataJson
    })
      .then((response) => {
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        return response.json();
        })
      .then((responseJson) => {
        const ListArray = responseJson.map(({ VC }) => ({
          value: VC,
          label: VC,
        }));
        setBcArray(ListArray);
      })
      .catch((error) => {});
  };

  const uploadFileData = () => {
    var input = document.createElement("input");
    input.type = "file";
    input.setAttribute(
      "accept",
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    );
    input.click();
    input.onchange = (e) => {
      setLoader(true);
      show(true);

      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      fetch(`${baseUrl}Show_Base_Vc_Data/`, {
        method: "PUT",
        body: formData,
      })
        .then((response) => {
          // eslint-disable-next-line radix
          let status1 = parseInt(response.status);
          if (status1 == "201") {
            //   document.removeChild(input);

            getTableData("No");
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: "file uploaded sucessfully",
              reload: true,
            });
          } else {
            showPopup({
              type: MESSAGE_TYPE.SUCCESS,
              contextText: MESSAGE_TYPE.SUCCESS,
              info: "file uploaded failed",
            });
          }
        })

        .catch((error) => {});
    };
  };

  const exportExcel = async (excelData) => {
    var fileTypel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    var fileExt = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypel });
    FileSaver.saveAs(data, `ColorVCDataCV${fileExt}`);
  };
  const filterExcel = async (excelData) => {
    var fileTypel =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    var fileExt = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileTypel });
    FileSaver.saveAs(data, `FilteredColorVCDataCV${fileExt}`);
  };

  const redirectToCreateProjectPage = () => history.push("/");
  const redirectToProjectEditPage = (id) => history.push(`/`);
  const redirectToProjectDetailsPage = (id) => history.push(`/`);

  const renderHTML = () => (
    <div className={styles.formGroup}>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Ticket No</label>
            </div>
            <div className={styles.formDiv}>
              <ValidatingTextField
                variant="outlined"
                size="small"
                isDisabled={false}
                //    value={myState.completeDate}
                inputProps={{
                  "data-testid": "remark-input",
                }}
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>BU</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isDisabled={myState.checkFlag}
                // isMandatory
                // markIfUnselected={highlightMandatoryFields}
                // resetAllVisitedFields={resetAllVisitedFields}
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                value={myState.bodyBuilder}
                onChange={(e) => {
                  handleSelect(e, "bodyBuilder");
                }}
                name="bodyBuilder"
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>BC Name</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isDisabled={myState.checkFlag}
                // isMandatory
                // markIfUnselected={highlightMandatoryFields}
                // resetAllVisitedFields={resetAllVisitedFields}
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                value={myState.bodyBuilder}
                onChange={(e) => {
                  handleSelect(e, "bodyBuilder");
                }}
                name="bodyBuilder"
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>

      <Grid
        container
        className={styles.myGrid}
        spacing={1}
        style={{marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Barrel</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isDisabled={myState.checkFlag}
                // isMandatory
                // markIfUnselected={highlightMandatoryFields}
                // resetAllVisitedFields={resetAllVisitedFields}
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                options={bodyBuilderOption}
                value={myState.bodyBuilder}
                onChange={(e) => {
                  handleSelect(e, "bodyBuilder");
                }}
                name="bodyBuilder"
              />
            </div>
          </div>
          {myState.bodyBuilderFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "81px" }} className={styles.error}>
              Body builder Code is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Project Description</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                // isMandatory
                // markIfUnselected={highlightMandatoryFields}
                // resetAllVisitedFields={resetAllVisitedFields}
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                options={chassisOption}
                value={myState.chassisNo}
                onChange={(e) => {
                  handleSelect(e, "chassisNo");
                }}
                name="rso"
                jointOption={false}
              />
            </div>
          </div>
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                markIfUnselected={highlightMandatoryFields}
                resetAllVisitedFields={resetAllVisitedFields}
                style={{
                  marginLeft: "21px",
                  marginRight: "11px",
                }}
                value="View"
              >
                {/* <FormControlLabel value="Yes" name="status" control={<Radio size="small" />} label="Yes" />
            <FormControlLabel value="No" name="status" control={<Radio size="small" />} label="No" /> */}

                <FormControlLabel
                  value="View"
                  name="status"
                  control={<Radio size="small" />}
                  label="View"
                />
                <FormControlLabel
                  value="Delete"
                  name="status"
                  control={<Radio size="small" />}
                  label="Delete"
                />
              </RadioGroup>
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={2} lg={2}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                // onClick={() => runPreSubmissionChecks() && handleSubmit()}
                //     disabled={(myState.chassisNo == null)}
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
              >
                Search
              </Button>

              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                onClick={handleOpen}
                style={{ marginRight: "5px" }}
              >
                Cancel
              </Button>
              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                onClick={handleOpen}
                style={{ marginRight: "5px" }}
              >
                Delete
              </Button>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                //     disabled={(myState.chassisNo == null)}
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
              >
                Export
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const renderReport = () => (
    <div className={styles.formGroup}>
      <div
        //  className={styles.customeTable}
        className={styles.col2}
        style={{
          width: "100%",
          height: "300px",
        }}
      >
        <Table
          columns={baseDefaultColumns}
          defaultColumns={baseDefaultColumns}
          rowHeight={ROW_HEIGHT}
          //   rows={tableData}
          rows={[
            {
              id: 0,
              Person: "919115",
              PersonName: "Pratik Tarade",
              Work: "PVBU ENGINEERING",
              BC: "1234564",
              Barrel: "EV",
              ProjectD: "W.22.EV19191",
              Project: "Testing",
              BU: "EV",
              Sub: "Adavance Engineering",
              Platform: "CAR",
              Family: "Nexon EV",
              Created: "24-12-2022",
              Inserted: "232323",
              InsertEMP: "Nilesh HariDeo",
            },
            {
              id: 1,
              Person: "919115",
              PersonName: "Pratik Tarade",
              Work: "PVBU ENGINEERING",
              BC: "1234564",
              Barrel: "EV",
              ProjectD: "W.22.EV19191",
              Project: "Testing",
              BU: "EV",
              Sub: "Adavance Engineering",
              Platform: "CAR",
              Family: "Nexon EV",
              Created: "24-12-2022",
              Inserted: "232323",
              InsertEMP: "Nilesh HariDeo",
            },
          ]}
          // primaryAction={{
          //   name: "submit",
          //   authOperation: 'create-project',
          //   shouldEnable: selected => selected.length === 1,
          //   actionFn: selected => {
          //     console.log(selected,"selected")

          //   },
          // }}
          secondaryActions={[
            {
              name: 'Delete Entry',
              authOperation: 'create-project',
              shouldEnable: selected => selected.length >= 1,
              actionFn: selected => {
                console.log(selected, "selected")
              },
            }
          ]}
          setAsnCount={setCount}
          isDataLoading={false}
          actionButtons
          //    onRowSelect={(e) => { console.log('onRowSelect call') }}
        />
      </div>
    </div>
  );

  return (
    <>
      <div className={styles.container} style={{ boxSizing: "border-box" }}>
            <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="HOME"
            handleClick={redirectToApplicationLandingPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Linkage Delete" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar}>
            <UserInfoPanel
              userInfo={[
                {
                  Name: "Aditya Mathur",
                  "SAP ID": 122355,
                  "BC No": "122355",
                  LOC: "Engineering and Research Center",
                },
              ]}
            />
          </div>
        </div>

        <div
          className={clsx(
            styles.scrollContainer,
            styles.scrollBar,
            styles.formContainer
          )}
        >
          <CustomFormGroup header="Linkage Delete" body={renderHTML()} />
          <CustomFormGroup header="Linkage Details" body={renderReport()} />
          {/* {tableData.length == 0 && (
            <CustomFormGroup header="Report Details" body={renderReport()} />
          )} */}
        </div>

        {flag && (
          <div
            className={styles.tableView}
            style={{ height: "86%", padding: "0 2em" }}
          >
            {/* <Table
              columns={[...baseDefaultColumns]}
              defaultColumns={[...baseDefaultColumns]}
              rowHeight={38}
              rows={tableArray}
              primaryAction={{
                name: "Submit Data",
                authOperation: "submit",
                shouldEnable: () => true,
                actionFn: handleOpenFormModal,
              }}
              secondaryActions={[
                // {
                //   name: 'Download Data',
                //   authOperation: 'create-project',
                //   shouldEnable: selected => true,
                //   actionFn: selected => {},
                //   customClass:""
                //  customClass:"btnDelete"

                // },

                {
                  name: "Upload Data",
                  authOperation: "upload",
                  // shouldEnable: selected => selected.length === 1,
                  shouldEnable: () => true,
                  actionFn: (selected) => {
                    handleOpen();
                  },
                  customClass: "",
                  //  customClass:"btnDelete"
                },
                {
                  name: "Delete",
                  authOperation: "delete",
                  shouldEnable: (selected) => selected.length >= 1,
                  actionFn: (selected) => {
                    handleOpen1(selected);
                  },
                  customClass: "btnDelete",
                },
              ]}
              setAsnCount={setCount}
              isDataLoading={loader}
              actionButtons
              onRowSelect={(e) => {}}
              // removeRowSelection
              filterDownload={filterExcel}
              filterDownloadBtn
            /> */}
          </div>
        )}
      </div>
      <ResetModalVC
        isPopupOpen={reseVC}
        handleCloseVCModal={handleCloseVCResetModal}
        resetVCCall={resetVCCall}
      />

      <ResetModalF
        isPopupOpen={isPopupOpenFormModal}
        handleCloseFormModal={handleCloseFormModal}
        goNextForm={goNextForm}
      />
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        goNext={goNext}
      />

      <ResetModal2
        isPopupOpen1={isPopupOpen1}
        handleClose1={handleClose1}
        goNext1={goNext1}
      />

      {/* <formModal
        isPopupOpen={isPopupOpenFormModal}
        handleCloseFormModal={handleCloseFormModal}
        goNextForm={goNextForm}

      /> */}
    </>
  );
};
function ResetModalVC({ isPopupOpen, handleCloseVCModal, resetVCCall }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm Reset
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>
              On confirmation, Selected VC BoM will get reset and all changes
              made will be lost
            </p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCloseVCModal}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleCloseVCModal();
              resetVCCall();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModalF({ isPopupOpen, handleCloseFormModal, goNextForm }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm Submit
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>On confirmation ,VC BoM data will submit</p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCloseFormModal}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleCloseFormModal();
              goNextForm();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, goNext }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Confirm file Upload
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            {/* <p> On confirmation, All existing data will be overwritten by the uploaded data.</p> */}
            <p>On confirmation ,Records will be appended.</p>

            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              goNext();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal2({ isPopupOpen1, handleClose1, goNext1 }) {
  return (
    <Dialog
      open={isPopupOpen1}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <WarningIcon style={{ height: "18px", width: "18px" }} />
            <span style={{ marginLeft: "8px" }} className={styles.txt}>
              Selected data will be deleted
            </span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <div>
            <p> On confirmation, Selected data will be deleted.</p>
            <p>Are you sure ?</p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose1}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              goNext1();
              handleClose1();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};
ResetModalF.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleCloseFormModal: PropTypes.func.isRequired,
  goNextForm: PropTypes.func.isRequired,
};
ResetModalVC.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleCloseVCModal: PropTypes.func.isRequired,
  resetVCCall: PropTypes.func.isRequired,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  isPopupOpen1: PropTypes.bool.isRequired,
  handleClose1: PropTypes.func.isRequired,
  goNext1: PropTypes.func.isRequired,
};

export default withAllowedOperationsProvider(
  LinkageDelete,
  RESOURCE_TYPE.PROJECT
);
